import { Spinner } from '@reflex/ui/components/shared/Spinner';
import type { LogsState } from './types';

interface SetupLogPanelProps {
  logs: LogsState | undefined;
  /** Pre-extracted log section to display. Pass `null` for "no section found". */
  section?: string | null;
  /** Empty-state hint when `section` is `null`. */
  emptySectionLabel?: string;
  /** Loading-state label. Defaults to "Loading logs…". */
  loadingLabel?: string;
}

export function SetupLogPanel({
  logs,
  section,
  emptySectionLabel,
  loadingLabel = 'Loading logs…',
}: SetupLogPanelProps) {
  if (!logs || logs.loading) {
    return (
      <div className="flex items-center gap-2 text-3xs text-muted-foreground">
        <Spinner size="xs" /> {loadingLabel}
      </div>
    );
  }
  if (logs.error) {
    return <p className="text-3xs text-status-error">{logs.error}</p>;
  }
  if (section !== undefined) {
    if (section === null) {
      return (
        <p className="text-3xs text-muted-foreground">{emptySectionLabel ?? '(no section)'}</p>
      );
    }
    return (
      <pre className="max-h-80 overflow-auto whitespace-pre-wrap font-mono text-3xs leading-relaxed text-foreground/80">
        {section || '(empty)'}
      </pre>
    );
  }
  return (
    <pre className="max-h-80 overflow-auto whitespace-pre-wrap font-mono text-3xs leading-relaxed text-foreground/80">
      {logs.content || '(no log)'}
    </pre>
  );
}
